export default "__VITE_ASSET__D1NbqNBX__"